import React, { useState } from 'react';
import { Button, Grid, useMediaQuery } from '@material-ui/core';
import theme from '../../styles/theme';
import FileUpload from './FileUpload';
import PropTypes from 'prop-types';

const FileUploader = ({ onUploadComplete, authStore, disableUpload = false, FileHostStore, clickedUploadButton }) => {
  const [showFileUpload, setShowFileUpload] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleToggleFileUpload = () => {
    setShowFileUpload((prev) => !prev);
    clickedUploadButton();
  };

  const handleUploadComplete = (fileName) => {
    setShowFileUpload(false);
    onUploadComplete(fileName);
  };

  return (
    <Grid container direction="column" style={{ marginBottom: '10px' }}>
      <Grid item container justifyContent={isSmallScreen ? 'center' : 'flex-end'}>
        <Button variant="contained" color="primary" onClick={handleToggleFileUpload} disabled={disableUpload}>
          Upload a new file
        </Button>
      </Grid>
      {showFileUpload && (
        <Grid item>
          <FileUpload onUploadComplete={handleUploadComplete} authStore={authStore} FileHostStore={FileHostStore} />
        </Grid>
      )}
    </Grid>
  );
};

FileUploader.propTypes = {
  FileHostStore: PropTypes.object,
  onUploadComplete: PropTypes.func.isRequired,
  authStore: PropTypes.object.isRequired,
  disableUpload: PropTypes.bool,
};

export default FileUploader;
